module.exports = __webpack_public_path__ + "img/sand-decal-26.13d5f888.png";